.vx-animated-multi-page-container {
  display: flex;
  flex-flow: row nowrap;
  height: 100vh;
  height: 100dvh;
  transition: transform 0.5s ease;
}